export const OrderDirectionMapping = {
  ascend: "ASC",
  descend: "DESC",
};
